module.exports = __webpack_public_path__ + "img/notice_icon.20f3aa19.png";